import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFamilyMembers } from '../../actions/familyMembersActions';
import { RootState } from '../../store'; // adjust the path as needed

const useFamilyMembers = () => {
	const dispatch = useDispatch<any>();
	const { loading, error, family } = useSelector((store: RootState) => store.familyMembersReducer);
	useEffect(() => {
		if (family === null && !error && !loading) {
			dispatch(getFamilyMembers());
		}
	}, [loading, error, family, dispatch]);

	return {
		family,
		error,
		loading,
	};
};

export default useFamilyMembers;
